const PDF_APIS_URL = process.env.VUE_APP_PDF_APIS_URL
const ENDPOINT_VALUES = {
  helthcheck: 'hc/',
  pdf: 'pdf/',
  pdfDownload: 'pdf_download/',
  html: 'html/test.html'
}

const pdfApisLib = {
  install: function (Vue, options) {
    //Vue.use(VueLocalForage)
    const main = new Vue({
      data: function () {
        return {}
      },
      computed: {
        endPoints: function () {
          let endPoints = {}
          Object.keys(ENDPOINT_VALUES).forEach(function (key) {
            endPoints[key] = PDF_APIS_URL + ENDPOINT_VALUES[key]
          })
          return endPoints
        }
      },
      mounted: function () {},
      methods: {}
    })
    Vue.prototype.$pdfApis = main
  }
}

export default pdfApisLib
